import { render, staticRenderFns } from "./SourceDocument.vue?vue&type=template&id=419af9a9&scoped=true&"
import script from "./SourceDocument.vue?vue&type=script&lang=js&"
export * from "./SourceDocument.vue?vue&type=script&lang=js&"
import style0 from "./SourceDocument.vue?vue&type=style&index=0&id=419af9a9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419af9a9",
  null
  
)

export default component.exports